// src/services/replenishmentApi.js

import api, { buildCompanyScopeHeaders } from "./api";

export const getReplenishments = ({ companyUuid } = {}) =>
  api
    .get("/admin/replenishment/list", {
      headers: buildCompanyScopeHeaders(companyUuid),
    })
    .then((r) => r.data);

export const getReplenishmentOrders = ({ companyUuid } = {}) =>
  api
    .get("/admin/replenishment/orders", {
      headers: buildCompanyScopeHeaders(companyUuid),
    })
    .then((r) => r.data);

export const getReplenishmentStatus = ({ companyUuid } = {}) =>
  api
    .get("/admin/replenishment/status", {
      headers: buildCompanyScopeHeaders(companyUuid),
    })
    .then((r) => r.data);

export const certifyReplenishment = (uuid, { companyUuid } = {}) =>
  api
    .post(
      `/admin/replenishment/${uuid}/certify`,
      {},
      {
        headers: buildCompanyScopeHeaders(companyUuid),
      }
    )
    .then((r) => r.data);